var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-popover',_vm._g(_vm._b({ref:"popover",attrs:{"placement":"left","triggers":""}},'b-popover',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.$t('text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }